@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

internal val Res.string.alert_banner_approaching_threat: StringResource by lazy {
      StringResource("string:alert_banner_approaching_threat", "alert_banner_approaching_threat", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 63),
      ))
    }

internal val Res.string.alert_banner_average: StringResource by lazy {
      StringResource("string:alert_banner_average", "alert_banner_average", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74, 32),
      ))
    }

internal val Res.string.alert_banner_closest: StringResource by lazy {
      StringResource("string:alert_banner_closest", "alert_banner_closest", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107, 48),
      ))
    }

internal val Res.string.alert_banner_maximum: StringResource by lazy {
      StringResource("string:alert_banner_maximum", "alert_banner_maximum", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156, 32),
      ))
    }

internal val Res.string.alert_banner_minimum: StringResource by lazy {
      StringResource("string:alert_banner_minimum", "alert_banner_minimum", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189, 32),
      ))
    }

internal val Res.string.alert_banner_strongest: StringResource by lazy {
      StringResource("string:alert_banner_strongest", "alert_banner_strongest", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222, 54),
      ))
    }

internal val Res.string.alert_confirm_dialog_text: StringResource by lazy {
      StringResource("string:alert_confirm_dialog_text", "alert_confirm_dialog_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 281, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277, 77),
      ))
    }

internal val Res.string.alert_confirm_dialog_title: StringResource by lazy {
      StringResource("string:alert_confirm_dialog_title", "alert_confirm_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 355, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 355, 54),
      ))
    }

internal val Res.string.alert_detected_on_sentinel: StringResource by lazy {
      StringResource("string:alert_detected_on_sentinel", "alert_detected_on_sentinel", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 414, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 410, 62),
      ))
    }

internal val Res.string.alert_disconnect_text: StringResource by lazy {
      StringResource("string:alert_disconnect_text", "alert_disconnect_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 481, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 473, 85),
      ))
    }

internal val Res.string.alert_disconnect_title: StringResource by lazy {
      StringResource("string:alert_disconnect_title", "alert_disconnect_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 575, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 559, 46),
      ))
    }

internal val Res.string.alert_orange_explanation: StringResource by lazy {
      StringResource("string:alert_orange_explanation", "alert_orange_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 626, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 606, 84),
      ))
    }

internal val Res.string.alert_red_explanation: StringResource by lazy {
      StringResource("string:alert_red_explanation", "alert_red_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 723, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 691, 61),
      ))
    }

internal val Res.string.alert_started_at: StringResource by lazy {
      StringResource("string:alert_started_at", "alert_started_at", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 801, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 753, 52),
      ))
    }

internal val Res.string.alert_title_ash: StringResource by lazy {
      StringResource("string:alert_title_ash", "alert_title_ash", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 10, 71),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 10, 67),
      ))
    }

internal val Res.string.alert_title_drizzle: StringResource by lazy {
      StringResource("string:alert_title_drizzle", "alert_title_drizzle", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 82, 79),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 78, 79),
      ))
    }

internal val Res.string.alert_title_dust: StringResource by lazy {
      StringResource("string:alert_title_dust", "alert_title_dust", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 162, 72),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 158, 72),
      ))
    }

internal val Res.string.alert_title_fog: StringResource by lazy {
      StringResource("string:alert_title_fog", "alert_title_fog", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 235, 71),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 231, 67),
      ))
    }

internal val Res.string.alert_title_haze: StringResource by lazy {
      StringResource("string:alert_title_haze", "alert_title_haze", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 307, 72),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 299, 72),
      ))
    }

internal val Res.string.alert_title_mist: StringResource by lazy {
      StringResource("string:alert_title_mist", "alert_title_mist", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 380, 72),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 372, 72),
      ))
    }

internal val Res.string.alert_title_none: StringResource by lazy {
      StringResource("string:alert_title_none", "alert_title_none", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 453, 96),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 445, 80),
      ))
    }

internal val Res.string.alert_title_rain: StringResource by lazy {
      StringResource("string:alert_title_rain", "alert_title_rain", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 550, 72),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 526, 72),
      ))
    }

internal val Res.string.alert_title_sandstorm: StringResource by lazy {
      StringResource("string:alert_title_sandstorm", "alert_title_sandstorm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 623, 85),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 599, 81),
      ))
    }

internal val Res.string.alert_title_smoke: StringResource by lazy {
      StringResource("string:alert_title_smoke", "alert_title_smoke", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 709, 73),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 681, 73),
      ))
    }

internal val Res.string.alert_title_snow: StringResource by lazy {
      StringResource("string:alert_title_snow", "alert_title_snow", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 783, 72),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 755, 72),
      ))
    }

internal val Res.string.alert_title_squall: StringResource by lazy {
      StringResource("string:alert_title_squall", "alert_title_squall", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 856, 78),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 828, 74),
      ))
    }

internal val Res.string.alert_title_threat_approaching: StringResource by lazy {
      StringResource("string:alert_title_threat_approaching", "alert_title_threat_approaching", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 935, 62),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 903, 62),
      ))
    }

internal val Res.string.alert_title_threat_overhead: StringResource by lazy {
      StringResource("string:alert_title_threat_overhead", "alert_title_threat_overhead", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 998, 55),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 966, 55),
      ))
    }

internal val Res.string.alert_title_thunderstorm: StringResource by lazy {
      StringResource("string:alert_title_thunderstorm", "alert_title_thunderstorm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 1054, 80),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 1022, 84),
      ))
    }

internal val Res.string.alert_title_tornado: StringResource by lazy {
      StringResource("string:alert_title_tornado", "alert_title_tornado", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/alerts.commonMain.cvr", 1135, 79),
        ResourceItem(setOf(), "${MD}values/alerts.commonMain.cvr", 1107, 79),
      ))
    }

internal val Res.string.alert_user_dialog_button_orange: StringResource by lazy {
      StringResource("string:alert_user_dialog_button_orange", "alert_user_dialog_button_orange", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 858, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 806, 47),
      ))
    }

internal val Res.string.alert_user_dialog_button_red: StringResource by lazy {
      StringResource("string:alert_user_dialog_button_red", "alert_user_dialog_button_red", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 906, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 854, 40),
      ))
    }

internal val Res.string.alert_user_dialog_button_yellow: StringResource by lazy {
      StringResource("string:alert_user_dialog_button_yellow", "alert_user_dialog_button_yellow", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 951, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 895, 47),
      ))
    }

internal val Res.string.alert_user_dialog_orange_text: StringResource by lazy {
      StringResource("string:alert_user_dialog_orange_text", "alert_user_dialog_orange_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 999, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 943, 125),
      ))
    }

internal val Res.string.alert_user_dialog_orange_title: StringResource by lazy {
      StringResource("string:alert_user_dialog_orange_title", "alert_user_dialog_orange_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1137, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1069, 54),
      ))
    }

internal val Res.string.alert_user_dialog_red_text: StringResource by lazy {
      StringResource("string:alert_user_dialog_red_text", "alert_user_dialog_red_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1196, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1124, 98),
      ))
    }

internal val Res.string.alert_user_dialog_red_title: StringResource by lazy {
      StringResource("string:alert_user_dialog_red_title", "alert_user_dialog_red_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1315, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1223, 47),
      ))
    }

internal val Res.string.alert_user_dialog_text: StringResource by lazy {
      StringResource("string:alert_user_dialog_text", "alert_user_dialog_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1367, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1271, 106),
      ))
    }

internal val Res.string.alert_user_dialog_title: StringResource by lazy {
      StringResource("string:alert_user_dialog_title", "alert_user_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1466, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1378, 63),
      ))
    }

internal val Res.string.alert_user_dialog_yellow_text: StringResource by lazy {
      StringResource("string:alert_user_dialog_yellow_text", "alert_user_dialog_yellow_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1526, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1442, 125),
      ))
    }

internal val Res.string.alert_user_dialog_yellow_title: StringResource by lazy {
      StringResource("string:alert_user_dialog_yellow_title", "alert_user_dialog_yellow_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1660, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1568, 54),
      ))
    }

internal val Res.string.alert_yellow_explanation: StringResource by lazy {
      StringResource("string:alert_yellow_explanation", "alert_yellow_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1715, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1623, 84),
      ))
    }

internal val Res.string.app_login_title: StringResource by lazy {
      StringResource("string:app_login_title", "app_login_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/login.commonMain.cvr", 10, 39),
        ResourceItem(setOf(), "${MD}values/login.commonMain.cvr", 10, 39),
      ))
    }

internal val Res.string.app_main_title: StringResource by lazy {
      StringResource("string:app_main_title", "app_main_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/login.commonMain.cvr", 50, 58),
        ResourceItem(setOf(), "${MD}values/login.commonMain.cvr", 50, 54),
      ))
    }

internal val Res.string.app_title_client: StringResource by lazy {
      StringResource("string:app_title_client", "app_title_client", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1708, 40),
      ))
    }

internal val Res.string.app_title_manager: StringResource by lazy {
      StringResource("string:app_title_manager", "app_title_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1749, 49),
      ))
    }

internal val Res.string.aqi_index: StringResource by lazy {
      StringResource("string:aqi_index", "aqi_index", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1808, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1799, 33),
      ))
    }

internal val Res.string.aqi_index_good: StringResource by lazy {
      StringResource("string:aqi_index_good", "aqi_index_good", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/aqi_index.commonMain.cvr", 10, 26),
        ResourceItem(setOf(), "${MD}values/aqi_index.commonMain.cvr", 10, 30),
      ))
    }

internal val Res.string.aqi_index_hazardous: StringResource by lazy {
      StringResource("string:aqi_index_hazardous", "aqi_index_hazardous", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/aqi_index.commonMain.cvr", 37, 39),
        ResourceItem(setOf(), "${MD}values/aqi_index.commonMain.cvr", 41, 39),
      ))
    }

internal val Res.string.aqi_index_moderate: StringResource by lazy {
      StringResource("string:aqi_index_moderate", "aqi_index_moderate", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/aqi_index.commonMain.cvr", 77, 38),
        ResourceItem(setOf(), "${MD}values/aqi_index.commonMain.cvr", 81, 38),
      ))
    }

internal val Res.string.aqi_index_unhealthy: StringResource by lazy {
      StringResource("string:aqi_index_unhealthy", "aqi_index_unhealthy", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/aqi_index.commonMain.cvr", 192, 55),
        ResourceItem(setOf(), "${MD}values/aqi_index.commonMain.cvr", 196, 39),
      ))
    }

internal val Res.string.aqi_index_unhealthy_sensitive_group: StringResource by lazy {
      StringResource("string:aqi_index_unhealthy_sensitive_group", "aqi_index_unhealthy_sensitive_group", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/aqi_index.commonMain.cvr", 116, 75),
        ResourceItem(setOf(), "${MD}values/aqi_index.commonMain.cvr", 120, 75),
      ))
    }

internal val Res.string.aqi_index_very_unhealthy: StringResource by lazy {
      StringResource("string:aqi_index_very_unhealthy", "aqi_index_very_unhealthy", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/aqi_index.commonMain.cvr", 248, 72),
        ResourceItem(setOf(), "${MD}values/aqi_index.commonMain.cvr", 236, 52),
      ))
    }

internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1850, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1833, 22),
      ))
    }

internal val Res.string.card_show_amount: StringResource by lazy {
      StringResource("string:card_show_amount", "card_show_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1877, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1856, 32),
      ))
    }

internal val Res.string.card_show_card_name: StringResource by lazy {
      StringResource("string:card_show_card_name", "card_show_card_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1914, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1889, 39),
      ))
    }

internal val Res.string.card_show_max: StringResource by lazy {
      StringResource("string:card_show_max", "card_show_max", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1966, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1929, 25),
      ))
    }

internal val Res.string.card_show_min: StringResource by lazy {
      StringResource("string:card_show_min", "card_show_min", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1992, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1955, 25),
      ))
    }

internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2018, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1981, 27),
      ))
    }

internal val Res.string.deck_configuration_deck_name: StringResource by lazy {
      StringResource("string:deck_configuration_deck_name", "deck_configuration_deck_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2132, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2091, 48),
      ))
    }

internal val Res.string.deck_configuration_deck_name_text: StringResource by lazy {
      StringResource("string:deck_configuration_deck_name_text", "deck_configuration_deck_name_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2046, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2009, 81),
      ))
    }

internal val Res.string.deck_configuration_deck_size: StringResource by lazy {
      StringResource("string:deck_configuration_deck_size", "deck_configuration_deck_size", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2185, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2140, 48),
      ))
    }

internal val Res.string.deck_configuration_hand_size: StringResource by lazy {
      StringResource("string:deck_configuration_hand_size", "deck_configuration_hand_size", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2246, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2189, 48),
      ))
    }

internal val Res.string.decks_cards: StringResource by lazy {
      StringResource("string:decks_cards", "decks_cards", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2303, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2238, 27),
      ))
    }

internal val Res.string.decks_no_decks: StringResource by lazy {
      StringResource("string:decks_no_decks", "decks_no_decks", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2331, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2266, 46),
      ))
    }

internal val Res.string.decks_title: StringResource by lazy {
      StringResource("string:decks_title", "decks_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2390, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2313, 27),
      ))
    }

internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2418, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2341, 22),
      ))
    }

internal val Res.string.dreamborn_url_or_id_text: StringResource by lazy {
      StringResource("string:dreamborn_url_or_id_text", "dreamborn_url_or_id_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2441, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2364, 88),
      ))
    }

internal val Res.string.dreamborn_url_or_id_title: StringResource by lazy {
      StringResource("string:dreamborn_url_or_id_title", "dreamborn_url_or_id_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2542, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2453, 57),
      ))
    }

internal val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2596, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2511, 20),
      ))
    }

internal val Res.string.go: StringResource by lazy {
      StringResource("string:go", "go", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2617, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2532, 14),
      ))
    }

internal val Res.string.invalid: StringResource by lazy {
      StringResource("string:invalid", "invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2632, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2547, 27),
      ))
    }

internal val Res.string.map_option_satellite: StringResource by lazy {
      StringResource("string:map_option_satellite", "map_option_satellite", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/map.commonMain.cvr", 10, 56),
        ResourceItem(setOf(), "${MD}values/map.commonMain.cvr", 10, 48),
      ))
    }

internal val Res.string.map_option_stormcells: StringResource by lazy {
      StringResource("string:map_option_stormcells", "map_option_stormcells", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/map.commonMain.cvr", 67, 53),
        ResourceItem(setOf(), "${MD}values/map.commonMain.cvr", 59, 45),
      ))
    }

internal val Res.string.menu_certificates: StringResource by lazy {
      StringResource("string:menu_certificates", "menu_certificates", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2660, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2575, 57),
      ))
    }

internal val Res.string.menu_disconnect: StringResource by lazy {
      StringResource("string:menu_disconnect", "menu_disconnect", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2722, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2633, 39),
      ))
    }

internal val Res.string.menu_profile: StringResource by lazy {
      StringResource("string:menu_profile", "menu_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2766, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2673, 32),
      ))
    }

internal val Res.string.menu_section_admin_admins: StringResource by lazy {
      StringResource("string:menu_section_admin_admins", "menu_section_admin_admins", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2795, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2706, 53),
      ))
    }

internal val Res.string.menu_section_admin_users: StringResource by lazy {
      StringResource("string:menu_section_admin_users", "menu_section_admin_users", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2760, 56),
      ))
    }

internal val Res.string.menu_section_main_map: StringResource by lazy {
      StringResource("string:menu_section_main_map", "menu_section_main_map", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2849, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2817, 49),
      ))
    }

internal val Res.string.menu_sentinels: StringResource by lazy {
      StringResource("string:menu_sentinels", "menu_sentinels", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2887, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2867, 42),
      ))
    }

internal val Res.string.menu_title_admin: StringResource by lazy {
      StringResource("string:menu_title_admin", "menu_title_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2934, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2910, 44),
      ))
    }

internal val Res.string.menu_title_main: StringResource by lazy {
      StringResource("string:menu_title_main", "menu_title_main", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2979, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2955, 31),
      ))
    }

internal val Res.string.menu_title_others: StringResource by lazy {
      StringResource("string:menu_title_others", "menu_title_others", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3015, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2987, 33),
      ))
    }

internal val Res.string.menu_title_sentinels: StringResource by lazy {
      StringResource("string:menu_title_sentinels", "menu_title_sentinels", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3049, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3021, 48),
      ))
    }

internal val Res.string.menu_title_user: StringResource by lazy {
      StringResource("string:menu_title_user", "menu_title_user", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3098, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3070, 31),
      ))
    }

internal val Res.string.new_scenario_option_draws: StringResource by lazy {
      StringResource("string:new_scenario_option_draws", "new_scenario_option_draws", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3138, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3102, 45),
      ))
    }

internal val Res.string.new_scenario_option_mulligan: StringResource by lazy {
      StringResource("string:new_scenario_option_mulligan", "new_scenario_option_mulligan", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3184, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3148, 48),
      ))
    }

internal val Res.string.new_scenario_text: StringResource by lazy {
      StringResource("string:new_scenario_text", "new_scenario_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3233, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3197, 97),
      ))
    }

internal val Res.string.new_scenario_title: StringResource by lazy {
      StringResource("string:new_scenario_title", "new_scenario_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3315, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3295, 54),
      ))
    }

internal val Res.string.now: StringResource by lazy {
      StringResource("string:now", "now", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3388, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3372, 15),
      ))
    }

internal val Res.string.now_after: StringResource by lazy {
      StringResource("string:now_after", "now_after", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3366, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3350, 21),
      ))
    }

internal val Res.string.ok: StringResource by lazy {
      StringResource("string:ok", "ok", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3416, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3388, 14),
      ))
    }

internal val Res.string.otd: StringResource by lazy {
      StringResource("string:otd", "otd", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3431, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3403, 15),
      ))
    }

internal val Res.string.otp: StringResource by lazy {
      StringResource("string:otp", "otp", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3447, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3419, 15),
      ))
    }

internal val Res.string.page_administrators_add_new_administrator_couldnt_invite_text:
    StringResource by lazy {
      StringResource("string:page_administrators_add_new_administrator_couldnt_invite_text", "page_administrators_add_new_administrator_couldnt_invite_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3463, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3435, 117),
      ))
    }

internal val Res.string.page_administrators_add_new_administrator_couldnt_invite_title:
    StringResource by lazy {
      StringResource("string:page_administrators_add_new_administrator_couldnt_invite_title", "page_administrators_add_new_administrator_couldnt_invite_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3585, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3553, 82),
      ))
    }

internal val Res.string.page_administrators_add_new_administrator_text: StringResource by lazy {
      StringResource("string:page_administrators_add_new_administrator_text", "page_administrators_add_new_administrator_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3664, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3636, 118),
      ))
    }

internal val Res.string.page_administrators_add_new_administrator_title: StringResource by lazy {
      StringResource("string:page_administrators_add_new_administrator_title", "page_administrators_add_new_administrator_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3779, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3755, 87),
      ))
    }

internal val Res.string.page_administrators_cant_invite: StringResource by lazy {
      StringResource("string:page_administrators_cant_invite", "page_administrators_cant_invite", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3879, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3843, 127),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("alert_banner_approaching_threat", Res.string.alert_banner_approaching_threat)
  map.put("alert_banner_average", Res.string.alert_banner_average)
  map.put("alert_banner_closest", Res.string.alert_banner_closest)
  map.put("alert_banner_maximum", Res.string.alert_banner_maximum)
  map.put("alert_banner_minimum", Res.string.alert_banner_minimum)
  map.put("alert_banner_strongest", Res.string.alert_banner_strongest)
  map.put("alert_confirm_dialog_text", Res.string.alert_confirm_dialog_text)
  map.put("alert_confirm_dialog_title", Res.string.alert_confirm_dialog_title)
  map.put("alert_detected_on_sentinel", Res.string.alert_detected_on_sentinel)
  map.put("alert_disconnect_text", Res.string.alert_disconnect_text)
  map.put("alert_disconnect_title", Res.string.alert_disconnect_title)
  map.put("alert_orange_explanation", Res.string.alert_orange_explanation)
  map.put("alert_red_explanation", Res.string.alert_red_explanation)
  map.put("alert_started_at", Res.string.alert_started_at)
  map.put("alert_title_ash", Res.string.alert_title_ash)
  map.put("alert_title_drizzle", Res.string.alert_title_drizzle)
  map.put("alert_title_dust", Res.string.alert_title_dust)
  map.put("alert_title_fog", Res.string.alert_title_fog)
  map.put("alert_title_haze", Res.string.alert_title_haze)
  map.put("alert_title_mist", Res.string.alert_title_mist)
  map.put("alert_title_none", Res.string.alert_title_none)
  map.put("alert_title_rain", Res.string.alert_title_rain)
  map.put("alert_title_sandstorm", Res.string.alert_title_sandstorm)
  map.put("alert_title_smoke", Res.string.alert_title_smoke)
  map.put("alert_title_snow", Res.string.alert_title_snow)
  map.put("alert_title_squall", Res.string.alert_title_squall)
  map.put("alert_title_threat_approaching", Res.string.alert_title_threat_approaching)
  map.put("alert_title_threat_overhead", Res.string.alert_title_threat_overhead)
  map.put("alert_title_thunderstorm", Res.string.alert_title_thunderstorm)
  map.put("alert_title_tornado", Res.string.alert_title_tornado)
  map.put("alert_user_dialog_button_orange", Res.string.alert_user_dialog_button_orange)
  map.put("alert_user_dialog_button_red", Res.string.alert_user_dialog_button_red)
  map.put("alert_user_dialog_button_yellow", Res.string.alert_user_dialog_button_yellow)
  map.put("alert_user_dialog_orange_text", Res.string.alert_user_dialog_orange_text)
  map.put("alert_user_dialog_orange_title", Res.string.alert_user_dialog_orange_title)
  map.put("alert_user_dialog_red_text", Res.string.alert_user_dialog_red_text)
  map.put("alert_user_dialog_red_title", Res.string.alert_user_dialog_red_title)
  map.put("alert_user_dialog_text", Res.string.alert_user_dialog_text)
  map.put("alert_user_dialog_title", Res.string.alert_user_dialog_title)
  map.put("alert_user_dialog_yellow_text", Res.string.alert_user_dialog_yellow_text)
  map.put("alert_user_dialog_yellow_title", Res.string.alert_user_dialog_yellow_title)
  map.put("alert_yellow_explanation", Res.string.alert_yellow_explanation)
  map.put("app_login_title", Res.string.app_login_title)
  map.put("app_main_title", Res.string.app_main_title)
  map.put("app_title_client", Res.string.app_title_client)
  map.put("app_title_manager", Res.string.app_title_manager)
  map.put("aqi_index", Res.string.aqi_index)
  map.put("aqi_index_good", Res.string.aqi_index_good)
  map.put("aqi_index_hazardous", Res.string.aqi_index_hazardous)
  map.put("aqi_index_moderate", Res.string.aqi_index_moderate)
  map.put("aqi_index_unhealthy", Res.string.aqi_index_unhealthy)
  map.put("aqi_index_unhealthy_sensitive_group", Res.string.aqi_index_unhealthy_sensitive_group)
  map.put("aqi_index_very_unhealthy", Res.string.aqi_index_very_unhealthy)
  map.put("cancel", Res.string.cancel)
  map.put("card_show_amount", Res.string.card_show_amount)
  map.put("card_show_card_name", Res.string.card_show_card_name)
  map.put("card_show_max", Res.string.card_show_max)
  map.put("card_show_min", Res.string.card_show_min)
  map.put("confirm", Res.string.confirm)
  map.put("deck_configuration_deck_name", Res.string.deck_configuration_deck_name)
  map.put("deck_configuration_deck_name_text", Res.string.deck_configuration_deck_name_text)
  map.put("deck_configuration_deck_size", Res.string.deck_configuration_deck_size)
  map.put("deck_configuration_hand_size", Res.string.deck_configuration_hand_size)
  map.put("decks_cards", Res.string.decks_cards)
  map.put("decks_no_decks", Res.string.decks_no_decks)
  map.put("decks_title", Res.string.decks_title)
  map.put("delete", Res.string.delete)
  map.put("dreamborn_url_or_id_text", Res.string.dreamborn_url_or_id_text)
  map.put("dreamborn_url_or_id_title", Res.string.dreamborn_url_or_id_title)
  map.put("edit", Res.string.edit)
  map.put("go", Res.string.go)
  map.put("invalid", Res.string.invalid)
  map.put("map_option_satellite", Res.string.map_option_satellite)
  map.put("map_option_stormcells", Res.string.map_option_stormcells)
  map.put("menu_certificates", Res.string.menu_certificates)
  map.put("menu_disconnect", Res.string.menu_disconnect)
  map.put("menu_profile", Res.string.menu_profile)
  map.put("menu_section_admin_admins", Res.string.menu_section_admin_admins)
  map.put("menu_section_admin_users", Res.string.menu_section_admin_users)
  map.put("menu_section_main_map", Res.string.menu_section_main_map)
  map.put("menu_sentinels", Res.string.menu_sentinels)
  map.put("menu_title_admin", Res.string.menu_title_admin)
  map.put("menu_title_main", Res.string.menu_title_main)
  map.put("menu_title_others", Res.string.menu_title_others)
  map.put("menu_title_sentinels", Res.string.menu_title_sentinels)
  map.put("menu_title_user", Res.string.menu_title_user)
  map.put("new_scenario_option_draws", Res.string.new_scenario_option_draws)
  map.put("new_scenario_option_mulligan", Res.string.new_scenario_option_mulligan)
  map.put("new_scenario_text", Res.string.new_scenario_text)
  map.put("new_scenario_title", Res.string.new_scenario_title)
  map.put("now", Res.string.now)
  map.put("now_after", Res.string.now_after)
  map.put("ok", Res.string.ok)
  map.put("otd", Res.string.otd)
  map.put("otp", Res.string.otp)
  map.put("page_administrators_add_new_administrator_couldnt_invite_text", Res.string.page_administrators_add_new_administrator_couldnt_invite_text)
  map.put("page_administrators_add_new_administrator_couldnt_invite_title", Res.string.page_administrators_add_new_administrator_couldnt_invite_title)
  map.put("page_administrators_add_new_administrator_text", Res.string.page_administrators_add_new_administrator_text)
  map.put("page_administrators_add_new_administrator_title", Res.string.page_administrators_add_new_administrator_title)
  map.put("page_administrators_cant_invite", Res.string.page_administrators_cant_invite)
}
